import { render, staticRenderFns } from "./PRRequestReport.vue?vue&type=template&id=eb23e9b2&"
import script from "./PRRequestReport.vue?vue&type=script&lang=js&"
export * from "./PRRequestReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports